export let ToolbarSize;

(function (ToolbarSize) {
  ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
  ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
  ToolbarSize[ToolbarSize["L"] = 4] = "L";
  ToolbarSize[ToolbarSize["M"] = 3] = "M";
  ToolbarSize[ToolbarSize["S"] = 2] = "S";
  ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
})(ToolbarSize || (ToolbarSize = {}));

export let ToolbarWidths;

(function (ToolbarWidths) {
  ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
  ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
  ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
  ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
  ToolbarWidths[ToolbarWidths["S"] = 370] = "S";
})(ToolbarWidths || (ToolbarWidths = {}));

export let ToolbarWidthsFullPage;

(function (ToolbarWidthsFullPage) {
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
  ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
})(ToolbarWidthsFullPage || (ToolbarWidthsFullPage = {}));